import { DEPTH_COLORS } from "../Cmarkdownmindmap/mindmap-constants";

export const DEFAULT_TIMELINE_SECTION_LABEL = "Timeline";

export const SECTION_COLORS = [...DEPTH_COLORS] as const;

export const PERIOD_SPACING = 170;
export const PERIOD_NODE_SIZE = 16;

export const EVENT_CARD_WIDTH = 150;
export const BATCH_MAX_HEIGHT = 220;
export const EVENT_SEPARATOR_COLOR = "rgba(255, 255, 255, 0.14)";

export const NODE_TO_CARD_GAP = 16;
export const NODE_TO_LABEL_GAP = 12;
export const PERIOD_LABEL_HEIGHT = 26;

export const SECTION_HEADER_HEIGHT = 26;
export const TIMELINE_VERTICAL_PADDING = 16;

export const PILLAR_WIDTH = 4;
export const PILLAR_BORDER_RADIUS = 2;

export const TRACK_HEIGHT = 2;
export const TRACK_GRADIENT =
  "linear-gradient(90deg, rgba(102, 254, 193, 0.1), rgba(102, 254, 193, 0.5), rgba(102, 254, 193, 0.1))";

export const NEEDLE_DOT_SIZE = 6;
export const NEEDLE_ENTRANCE_DELAY_MS = 1200;
export const NEEDLE_FADE_IN_MS = 250;
export const NEEDLE_FADE_OUT_MS = 400;
export const NEEDLE_SNAP_SPRING = {
  stiffness: 400,
  damping: 35,
  mass: 0.5,
} as const;

export const PROXIMITY_RADIUS_PX = 240;
export const DIMMED_OPACITY = 0.45;
export const TRANSITION_DURATION = "150ms";
export const TRACK_HIGHLIGHT_WIDTH = 200;

export const TRACK_DRAW_DURATION_MS = 600;
export const NODE_ENTRANCE_DELAY_PER_MS = 60;
export const CARD_ENTRANCE_DELAY_PER_MS = 30;
export const CARD_ENTRANCE_BASE_DELAY_MS = 400;

export const CARD_TEXT_COLOR = "rgba(255, 255, 255, 0.72)";
export const CARD_TEXT_COLOR_FOCUSED = "rgba(255, 255, 255, 0.92)";

export const NODE_BLOOM_RING_SIZE = 20;
export const NODE_BLOOM_DURATION_MS = 600;
export const NODE_FOCUSED_SCALE = 1.2;
export const NODE_BREATHING_SCALE = 1.06;
export const NODE_BREATHING_DURATION_S = 3;

export const PERIOD_WASH_WIDTH = 160;

export const RULER_LINE_COLOR = "rgba(102, 254, 193, 0.05)";
export const RULER_SECTION_LINE_COLOR = "rgba(102, 254, 193, 0.1)";

export const TOOLTIP_BACKGROUND = "rgba(12, 16, 24, 0.98)";
export const TOOLTIP_BORDER = "1px solid rgba(255, 255, 255, 0.08)";

export const SCROLL_FADE_WIDTH = 24;

export const MIN_CONTAINER_HEIGHT = 120;
export const MAX_CONTAINER_HEIGHT = 600;

export const CONTAINER_PADDING = 8;
export const TITLE_ROW_HEIGHT = 30;
export const TOOLBAR_HEIGHT = 36;

export const SECTION_DIVIDER_COLOR = "rgba(255, 255, 255, 0.04)";
